import { Environment } from './environment';

export const testEnvironment: Environment = {
  name: 'test',
  auth0Domain: 'login-test.sama.com',
  auth0ClientId: 'test-client-id',
  annotationStoreServiceBaseUrl: 'https://annotation-store-url.com',
  clientCalibrationBaseUrl: 'https://client-calibration-url.com',
  taskServiceBaseUrl: 'https://task-url.com',
  assetServiceBaseUrl: 'https://asset-url.com',
  authorizationServiceBaseUrl: 'https://authorization-url.com',
  autoQaServiceBaseUrl: 'https://auto-qa-url.com',
  checkShaderErrors: true,
  draftSavePeriod: 60000,
  featureFlagServiceBaseUrl: 'https://feature-flag-url.com',
  outputMinHeight: 400,
  previewWorkspacePointCloudAssetUrl: '',
  targetEnhancedPointCount: 3000,
  samplingBackendServiceBaseUrl: 'https://sampling-url.com',
  samplingPortalServiceBaseUrl: 'https://sampling-portal-url.com',
  seedDataPointCloudTaskId: '',
  seedDataSensorFusionTaskId: '',
  settingsServiceBaseUrl: 'https://example.com',
  sh3BaseUrl: 'https://sh3-url.com',
  shouldDebounceRendering: false,
  shouldForceWebglContextLoss: false,
  shouldMakeHackyStoreForImageAnnotationTests: true,
  // True so we can stub and test, but stubs prevent actually sending calls
  shouldSendDebugLogs: true,
  shouldSendErrorsToRollbar: false,
  shouldShowAddRandomShapes: false,
  shouldUseSegmentTracker: false,
  shouldUseResizeObserver: false,
};
